import YWDPD_Modal_Manager from './modal-manager';

jQuery( document ).ready( function () {
	new YWDPD_Modal_Manager();
} );
